/** Protection while a local bookmark removal is waiting for Nexus indexing. */
export const BOOKMARK_REMOVAL_PROTECTION_MS = 300_000;
